import React from 'react';
import { LockText, ValidationLevel } from 'ui';
import { ResponsibleForUnitCardProps } from './types';
import { SelectedOption } from 'ui/common/select/selected-options/selected-option';
import styles from './responsible-for-unit-card.scss';

export const ResponsibleForUnitCard: React.FC<ResponsibleForUnitCardProps> = (props) => {

  const { label, values: valueItems, translation, validation: { messages = [] } = {} } = props;

  const level = messages[0]?.level;
  const errorStyle = messages[0]?.level === ValidationLevel.error ? styles.hasDanger : '';

  const groupClassname = `col-lg-6 ${level === undefined ? 'valid' : ''}`;
  const shouldRenderHeader = !!label || !!messages.length;

  return <div className={groupClassname}>
    <div className={styles.cardContainer}>
      <div className={`${styles.card} ${errorStyle} ${styles.readOnly}`}>
        {shouldRenderHeader && <div className={styles.header}>
          <div className="control-label pl-0 mb-0">
            {!!label && <h3>{label}</h3>}
            <LockText text={translation.contact_administrator_info} />
          </div>
        </div>}
        <ol className={styles.content}>
          {valueItems.map(item => <li key={item.value} className={styles.selectedOption}>
            <SelectedOption item={item} onRemove={undefined} readOnly={true} />
          </li>)}
        </ol>
      </div>
    </div>
  </div>;
};
